module.exports = __webpack_public_path__ + "static/media/study.41b437a6.png";